import { useRenameStorageObject } from "./hook/use-rename-storage-object";
import type { TRenameInputType } from "./types";
import { AppInput } from "../../shared/components/AppInput";
import { AppTextField } from "../../shared/components/AppInput/AppTextField";
import { ChangeEvent } from "react";
import { StorageScope } from "../../services/api/instances/storageApi/types/service_types";
import styles from "./styles.module.css";
import { useAppDispatch } from "../../services/redux/hooks/use-dispatch";
import { createNotification } from "../../app/state/notificationSlice/slice";

interface Props {
  service: StorageScope;
  inputType: TRenameInputType;
  handleChangeName?: (name: string) => void;
  isDisabled?: boolean;
  className?: string;
}

export const RenameObjectInput = ({
  service,
  inputType,
  isDisabled,
  handleChangeName,
  className,
}: Props) => {
  const { name, setName, selectedObject, updateObjectName } =
    useRenameStorageObject(service);

  const handleChange = (
    event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
  ) => {
    const newName = event.target.value;
    setName(newName);
    if (handleChangeName) {
      handleChangeName(newName);
    }
  };

  if (inputType === "input") {
    return (
      <AppInput
        value={name}
        onChange={(e) =>
          handleChangeName ? handleChange(e) : updateObjectName(e)
        }
        disabled={isDisabled || !selectedObject?.write}
        className={className}
      />
    );
  }

  return (
    <AppTextField
      value={name}
      onChange={(e) =>
        handleChangeName ? handleChange(e) : updateObjectName(e)
      }
      variant={"standard"}
      disabled={isDisabled || !selectedObject?.write}
      className={className}
    />
  );
};
